import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'

export const RecencyScoreHelpContent = ({ onDismiss }: { onDismiss: () => void }) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        ScreenName: 'MF_L2_Elite',
        eventId: 'Recency_Score'
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc='/images/mf-l2/recency-score-bottom-sheet.svg'
      heading='Recency Score'
      onDismiss={onDismiss}
    >
      <div className='text-[#6A6E6E] text-[14px] font-[400]'>
        Shows how the fund has performed in the last 2 years, reflecting its{' '}
        <span className='text-[#232323] text-[14px] font-[500]'> recent momentum and trend </span>. <br />
        <br /> A higher score means stronger recent performance compared to other funds in its category.
        <br />
        <br /> Use this to identify funds that are{' '}
        <span className='text-[#232323] text-[14px] font-[500]'> gaining pace or starting to slow down </span>.
      </div>
    </BottomSheetContent>
  )
}
